import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { useHeaderButtonContext } from "@/components/Navigation/Buttons/HeaderButton/context/headerButton.context";

type Props = {
    className?: string;
};

export const Alerts = ({ className }: Props) => {
    const { alerts } = useHeaderButtonContext();

    if (!isDefined(alerts)) return null;

    return (
        <span
            className={cn(
                "tw:rounded-full tw:px-0.5 tw:min-w-5 tw:min-h-5 tw:absolute tw:-right-1 tw:text-sm tw:leading-5 tw:font-semibold tw:text-center",
                className
            )}
        >
            {alerts}
        </span>
    );
};
